import { css } from '@compiled/react';
import ProfileHeader from './profile-header/ProfileHeader';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from 'components/common/fallback/Fallback';
import { logBoundaryError } from 'services/logger';
import { TABLET, DESKTOP } from '../../../constants/breakpoints';

const TopPanel = () => {
  return (
    <div css={topPanelStyles}>
      <div css={contentStyles}>
        <ErrorBoundary FallbackComponent={Fallback} onError={logBoundaryError}>
          <ProfileHeader />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default TopPanel;

export const NAV_BAR_HEIGHT = 55;

export const MOBILE_COVER_IMAGE_HEIGHT = 175;
export const TABLET_COVER_IMAGE_HEIGHT = 194;
export const DESKTOP_COVER_IMAGE_HEIGHT = 275;

const topPanelStyles = css({
  border: '1px solid transparent',
  marginBottom: '32px',
  [`@media (min-width: ${TABLET.MIN_WIDTH}px)`]: {
    marginBottom: '24px',
  },
});

const contentStyles = css({
  border: 'none',
  marginBottom: '10px',
  justifyContent: 'space-between',
  position: 'relative',
  maxWidth: '1280px',
  margin: `calc(${MOBILE_COVER_IMAGE_HEIGHT}px - ${NAV_BAR_HEIGHT}px) auto 0`,
  [`@media (min-width: ${TABLET.MIN_WIDTH}px)`]: {
    margin: `calc(${TABLET_COVER_IMAGE_HEIGHT}px - ${NAV_BAR_HEIGHT}px) auto 0`,
  },
  [`@media (min-width: ${DESKTOP.MIN_WIDTH}px)`]: {
    margin: `calc(${DESKTOP_COVER_IMAGE_HEIGHT}px - ${NAV_BAR_HEIGHT}px) auto 0`,
  },
});
